module.exports = __webpack_public_path__ + "site_static/img/mall2.7859505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall2.png
// module id = WtKh
// module chunks = 0